import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=02ffc26f&scoped=true"
import script from "./Notification.vue?vue&type=script&lang=js"
export * from "./Notification.vue?vue&type=script&lang=js"
import style0 from "./Notification.vue?vue&type=style&index=0&id=02ffc26f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ffc26f",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LightCross: require('C:/app/components/Svgs/LightCross.vue').default})
